import { render, staticRenderFns } from "./ArrowIcon.vue?vue&type=template&id=a3633e94&scoped=true&"
import script from "./ArrowIcon.vue?vue&type=script&lang=ts&"
export * from "./ArrowIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ArrowIcon.vue?vue&type=style&index=0&id=a3633e94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3633e94",
  null
  
)

export default component.exports